import { useState, useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function CasesPage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const cases = [
    {
      category: '製造業',
      title: '傳統製造業轉型升級',
      challenge: '需要資金購置自動化設備，提升生產效率',
      solution: '成功媒合銀行設備貸款，協助企業完成智慧製造轉型',
      result: '生產效率提升40%，人力成本降低25%',
      amount: '依需求而定',
      period: '6個月',
      icon: 'ri-settings-3-line',
      image: 'https://public.readdy.ai/ai/img_res/f6f1510849e2c36b21ddb94de2aa9a4f.jpg'
    },
    {
      category: '科技業',
      title: '軟體新創擴張資金',
      challenge: 'SaaS平台需要資金進行市場拓展與團隊擴編',
      solution: '媒合創投基金，獲得成長期投資',
      result: '成功拓展東南亞市場，用戶數成長3倍',
      amount: '依需求而定',
      period: '4個月',
      icon: 'ri-code-box-line',
      image: 'https://readdy.ai/api/search-image?query=Tech%20startup%20office%20environment%2C%20software%20developers%20working%20on%20computers%2C%20modern%20workspace%2C%20innovation%20and%20technology%2C%20collaborative%20tech%20team%2C%20clean%20professional%20setting%2C%20startup%20culture%20atmosphere&width=800&height=500&seq=case-tech-001&orientation=landscape'
    },
    {
      category: '零售業',
      title: '連鎖餐飲品牌展店',
      challenge: '計劃開設10家分店，需要大量展店資金',
      solution: '整合銀行貸款與私募基金，提供完整資金方案',
      result: '成功開設12家分店，年營收成長150%',
      amount: '依需求而定',
      period: '5個月',
      icon: 'ri-store-2-line',
      image: 'https://readdy.ai/api/search-image?query=Modern%20restaurant%20chain%20interior%2C%20elegant%20dining%20space%2C%20successful%20food%20business%2C%20multiple%20restaurant%20locations%2C%20clean%20professional%20design%2C%20hospitality%20industry%2C%20thriving%20business%20atmosphere&width=800&height=500&seq=case-retail-001&orientation=landscape'
    },
    {
      category: '貿易業',
      title: '進出口商票據融資',
      challenge: '訂單量大增，需要短期週轉金支應貨款',
      solution: '協助取得應收帳款融資，改善現金流',
      result: '順利完成大額訂單，營收成長200%',
      amount: '依需求而定',
      period: '2個月',
      icon: 'ri-ship-line',
      image: 'https://readdy.ai/api/search-image?query=International%20trade%20logistics%2C%20cargo%20containers%20at%20port%2C%20import%20export%20business%2C%20global%20commerce%2C%20shipping%20industry%2C%20professional%20trade%20operations%2C%20modern%20logistics%20facility&width=800&height=500&seq=case-trade-001&orientation=landscape'
    },
    {
      category: '服務業',
      title: '健身中心連鎖擴張',
      challenge: '品牌知名度高，需要資金快速展店搶佔市場',
      solution: '媒合私募基金投資，提供展店與行銷資金',
      result: '一年內開設8家分店，會員數突破萬人',
      amount: '依需求而定',
      period: '6個月',
      icon: 'ri-heart-pulse-line',
      image: 'https://readdy.ai/api/search-image?query=Modern%20fitness%20center%20gym%20interior%2C%20professional%20gym%20equipment%2C%20health%20and%20wellness%20facility%2C%20active%20lifestyle%20space%2C%20clean%20contemporary%20design%2C%20fitness%20industry%20success&width=800&height=500&seq=case-service-001&orientation=landscape'
    },
    {
      category: '醫療業',
      title: '診所設備更新',
      challenge: '需要購置先進醫療設備，提升診療品質',
      solution: '成功申請醫療設備融資租賃方案',
      result: '服務品質提升，病患滿意度達95%',
      amount: '依需求而定',
      period: '3個月',
      icon: 'ri-hospital-line',
      image: 'https://readdy.ai/api/search-image?query=Modern%20medical%20clinic%20interior%2C%20advanced%20medical%20equipment%2C%20professional%20healthcare%20facility%2C%20clean%20hospital%20environment%2C%20medical%20technology%2C%20quality%20healthcare%20setting&width=800&height=500&seq=case-medical-001&orientation=landscape'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar scrolled={scrolled} />
      
      <div className="pt-32 pb-24 bg-gradient-to-br from-black to-gray-800">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <h1 className="text-5xl font-bold text-white mb-6">成功案例</h1>
          <p className="text-xl text-white/90 max-w-3xl">
            真實的成功案例分享，見證朋睿如何協助企業達成目標
          </p>
        </div>
      </div>

      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">橫跨多個產業的成功經驗</h2>
            <div className="w-20 h-1 bg-black mx-auto mb-6"></div>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              從製造業到服務業，從新創到成熟企業，我們協助各產業企業取得所需資金
            </p>
          </div>

          <div className="space-y-12">
            {cases.map((caseItem, index) => (
              <div
                key={index}
                className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${
                  index % 2 === 1 ? 'lg:flex-row-reverse' : ''
                }`}
              >
                <div className={index % 2 === 1 ? 'lg:order-2' : ''}>
                  <img
                    src={caseItem.image}
                    alt={caseItem.title}
                    className="w-full h-[400px] object-cover rounded-2xl shadow-xl"
                  />
                </div>

                <div className={index % 2 === 1 ? 'lg:order-1' : ''}>
                  <div className="inline-block px-4 py-2 bg-black/10 rounded-full mb-4">
                    <span className="text-black font-bold text-sm">{caseItem.category}</span>
                  </div>
                  
                  <h3 className="text-3xl font-bold text-gray-900 mb-6 flex items-center">
                    <div className="w-12 h-12 bg-black/10 rounded-lg flex items-center justify-center mr-4">
                      <i className={`${caseItem.icon} text-2xl text-black`}></i>
                    </div>
                    {caseItem.title}
                  </h3>

                  <div className="space-y-4 mb-6">
                    <div>
                      <h4 className="font-bold text-gray-900 mb-2 flex items-center">
                        <i className="ri-error-warning-line text-black mr-2"></i>
                        挑戰
                      </h4>
                      <p className="text-gray-600 leading-relaxed pl-6">{caseItem.challenge}</p>
                    </div>

                    <div>
                      <h4 className="font-bold text-gray-900 mb-2 flex items-center">
                        <i className="ri-lightbulb-line text-black mr-2"></i>
                        解決方案
                      </h4>
                      <p className="text-gray-600 leading-relaxed pl-6">{caseItem.solution}</p>
                    </div>

                    <div>
                      <h4 className="font-bold text-gray-900 mb-2 flex items-center">
                        <i className="ri-trophy-line text-black mr-2"></i>
                        成果
                      </h4>
                      <p className="text-gray-600 leading-relaxed pl-6">{caseItem.result}</p>
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-4">
                    <div className="bg-gray-50 rounded-xl p-4">
                      <div className="text-sm text-gray-600 mb-1">媒合金額</div>
                      <div className="text-xl font-bold text-black">{caseItem.amount}</div>
                    </div>
                    <div className="bg-gray-50 rounded-xl p-4">
                      <div className="text-sm text-gray-600 mb-1">完成時間</div>
                      <div className="text-xl font-bold text-black">{caseItem.period}</div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-20 bg-gradient-to-br from-black to-gray-800 rounded-2xl p-12 text-center text-white">
            <h2 className="text-3xl font-bold mb-6">下一個成功案例就是您</h2>
            <p className="text-xl mb-8 text-white/90">
              立即聯繫我們，讓朋睿協助您達成商業目標
            </p>
            <a
              href="https://line.me/R/ti/p/@678gwbht"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-8 py-4 bg-white text-black rounded-full font-bold text-lg hover:bg-gray-100 transition-colors whitespace-nowrap"
            >
              <i className="ri-chat-3-line text-2xl mr-3"></i>
              LINE 諮詢
            </a>
          </div>
        </div>
      </section>

      <Footer />
      
      {/* LINE 客服按鈕 */}
      <a
        href="https://line.me/R/ti/p/@678gwbht"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-28 right-6 z-40 w-14 h-14 bg-[#06C755] rounded-full flex items-center justify-center text-white shadow-lg hover:scale-110 transition-transform duration-300 group"
        aria-label="LINE 即時諮詢"
      >
        <i className="ri-line-fill text-2xl"></i>
        <span className="absolute right-16 bg-gray-900 text-white px-3 py-1 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          LINE 即時諮詢
        </span>
      </a>
    </div>
  );
}
